import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    24: [
        'M18 4c2.76 0 5 2.242 5 4.996v4.008A4.992 4.992 0 0118.01 18h-2.596l-2.351 2.351a1.505 1.505 0 01-2.126 0L8.586 18H5.99A4.998 4.998 0 011 13.004V8.996A5 5 0 016 4h12zm0 2H6C4.343 6 3 7.342 3 8.996v4.008A2.998 2.998 0 005.99 16h3.424L12 18.586 14.586 16h3.423A2.992 2.992 0 0021 13.004V8.996A3.003 3.003 0 0018 6zm-6 3.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112 9.5zm5 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0117 9.5zm-10 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 017 9.5z',
    ],
};
const IconComment = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconComment.displayName = 'IconComment';

export { IconComment };
//# sourceMappingURL=IconComment.js.map
